import { UpdateResolver } from "@urql/exchange-graphcache";


export const appUpdates: {
    [fieldName: string]: UpdateResolver;
} = {
    updateStatus: (result, args, cache, info) => {

        // Note: This is where I assume we update the cache automatically
        // but this isn't necessarily getting reached.
    }
}